// AWS Configuration for Snatched Dashboard
// These values are populated from environment variables

export const region = import.meta.env.VITE_AWS_REGION || 'eu-north-1'

// Cognito Hosted UI domain for Google OAuth redirect flow
const cognitoDomain = import.meta.env.VITE_COGNITO_DOMAIN || ''

// All valid redirect URLs — Amplify v6 auto-selects the one matching window.location.origin
const defaultRedirectsIn = ['http://localhost:3000/', 'https://replyforge.ai/', 'https://dashboard.replyforge.ai/']
const defaultRedirectsOut = ['http://localhost:3000/login', 'https://replyforge.ai/login', 'https://dashboard.replyforge.ai/login']

const redirectSignIn = import.meta.env.VITE_OAUTH_REDIRECT_SIGN_IN
  ? import.meta.env.VITE_OAUTH_REDIRECT_SIGN_IN.split(',').map((u: string) => u.trim())
  : defaultRedirectsIn
const redirectSignOut = import.meta.env.VITE_OAUTH_REDIRECT_SIGN_OUT
  ? import.meta.env.VITE_OAUTH_REDIRECT_SIGN_OUT.split(',').map((u: string) => u.trim())
  : defaultRedirectsOut

export const awsConfig = {
  Auth: {
    Cognito: {
      region,
      userPoolId: import.meta.env.VITE_USER_POOL_ID || '',
      userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID || '',
      identityPoolId: import.meta.env.VITE_IDENTITY_POOL_ID || '',
      loginWith: {
        email: true,
        ...(cognitoDomain ? {
          oauth: {
            domain: cognitoDomain,
            scopes: ['email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
            redirectSignIn: redirectSignIn,
            redirectSignOut: redirectSignOut,
            responseType: 'code' as const,
          },
        } : {}),
      },
      signUpVerificationMethod: 'code' as const,
      userAttributes: {
        email: { required: true },
      },
      passwordFormat: {
        minLength: 8,
        requireLowercase: true,
        requireUppercase: true,
        requireNumbers: true,
      },
    },
  },
}

// Helper to check if Google OAuth is configured
export const isGoogleOAuthConfigured = (): boolean => !!cognitoDomain

// API Configuration
export const apiConfig = {
  baseUrl: (import.meta.env.VITE_API_URL || 'https://chbp18qo6g.execute-api.eu-north-1.amazonaws.com/dev').replace(/\/+$/, ''),
  wsUrl: import.meta.env.VITE_WS_URL || 'wss://f72cjhtr82.execute-api.eu-north-1.amazonaws.com/dev',
}

// Feature flags
export const features = {
  enableAnalytics: import.meta.env.VITE_ENABLE_ANALYTICS === 'true',
  enableShopifyIntegration: import.meta.env.VITE_ENABLE_SHOPIFY === 'true',
  enableGmailIntegration: import.meta.env.VITE_ENABLE_GMAIL === 'true',
  enableKnowledgeBase: false,
}

// Helper to check if Cognito is configured with valid values
export const isCognitoConfigured = (): boolean => {
  const poolId = import.meta.env.VITE_USER_POOL_ID
  const clientId = import.meta.env.VITE_USER_POOL_CLIENT_ID

  // Check if values exist and are not placeholder strings
  const isValid = !!(
    poolId &&
    clientId &&
    poolId !== 'undefined' &&
    poolId !== 'null' &&
    clientId !== 'undefined' &&
    clientId !== 'null' &&
    poolId.length > 0 &&
    clientId.length > 0
  )

  if (!isValid) {
    console.log('Cognito configuration check:', {
      hasPoolId: !!poolId,
      hasClientId: !!clientId,
      poolIdValue: poolId ? `${poolId.substring(0, 10)}...` : 'missing',
      clientIdValue: clientId ? `${clientId.substring(0, 10)}...` : 'missing',
    })
  }

  return isValid
}
